import { KlartextEventConfig } from '@common/types/klartextEventConfig';
import { intervalToDuration } from 'date-fns';

export const getElapsedTime = (start: Date, end: Date) => {
  const duration = intervalToDuration({
    start: start,
    end: end,
  });
  return `${String(duration.minutes ?? 0).padStart(2, '0')}:${String(duration.seconds ?? 0).padStart(2, '0')}`;
};

export const isRecording = (klartextEventConfig?: KlartextEventConfig<object> | null) => {
  return (
    !!klartextEventConfig && !klartextEventConfig.transcriptionEndTime && !!klartextEventConfig.transcriptionStartTime
  );
};

export const isRecordingDone = (speechConfig?: KlartextEventConfig<object> | null) => {
  return !!speechConfig && !!speechConfig.transcriptionEndTime && !!speechConfig.transcriptionStartTime;
};
